import GlobalWrapper from '../../components/Wrapper/GlobalWrapper';
import DataAnalyticsCards from './components/DataAnalyticsCards';

export default function DataAnalyticsLanding() {
  return (
    <GlobalWrapper title={'Data Analytics'}>
      <DataAnalyticsCards />
    </GlobalWrapper>
  );
}
